export default "__VITE_ASSET__DQcdiFtT__"